define("ember-svg-jar/inlined/time-ago", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<g clip-path=\"url(#clip0_3197_98201)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.287 9.102a.655.655 0 010 .949.732.732 0 01-.474.203.732.732 0 01-.474-.203L8.306 8.018a.615.615 0 01-.203-.474v-3.33c0-.406.27-.677.677-.677.406 0 .677.271.677.678l.001 3.058 1.83 1.83z\" fill=\"#323B43\"/><circle cx=\"8.662\" cy=\"7.729\" r=\"6.757\" stroke=\"#323B43\" stroke-width=\"1.279\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-dasharray=\"2.73 3.29\"/></g><defs><clipPath id=\"clip0_3197_98201\"><path fill=\"#fff\" transform=\"translate(.5)\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
    "attrs": {
      "width": "17",
      "height": "16",
      "viewBox": "0 0 17 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  };
});